module.exports = __webpack_public_path__ + "static/media/multiroom.75b46bab.jpg";